import React, { useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import * as routeLink from "./../../constants/routeLink";
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from "./../../actions/index";
const usePageTitle = () => {
  const location = useLocation();
  const path = location.pathname;

  // Tách tên trang từ path
  const pageTitle = path.substring(1) || 'home'; // Loại bỏ dấu "/" và lấy phần còn lại, mặc định là "home"

  return pageTitle;
};

const pageGroup = {
  home: "home",
  earn: "earn",
  friends: "friends",
  task: "task",
  ["daily-rewards"]: "task",
  ["shop-dogs"]: "home",


}
const Index = (props) => {
  const dispatch = useDispatch()
  const { appReducer } = useSelector(state => state);
  const pageTitle = usePageTitle();

  const curentPage = pageGroup[pageTitle];
  console.log(curentPage);

  return (
    <div className='tabs-bottom card-custom align-items-center w-100 d-grid-4'>
      <Link to={routeLink.HOME}
        onClick={() => {
          dispatch(Actions.setKeyTabBottom("Home"))
        }}
        className={`d-flex flex-column justify-content-center tabs-bottom-item align-items-center ${curentPage == "home" ? "active" : ""}`}>
        <i className="fas fa-home"></i><span className='d-flex fw-bold mt-2'>Home</span> </Link>
      <Link
        onClick={() => {
          dispatch(Actions.setKeyTabBottom("Earn"))
        }}
        to={routeLink.EARN} className={`d-flex flex-column justify-content-center tabs-bottom-item align-items-center ${curentPage == "earn" ? "active" : ""}`}><i className="fas fa-home"></i><span className='d-flex fw-bold mt-2'>Earn</span></Link>
      <Link onClick={() => {
        dispatch(Actions.setKeyTabBottom("Friends"))
      }} to={routeLink.FRIENDS} className={`d-flex flex-column justify-content-center tabs-bottom-item align-items-center ${curentPage == "friends" ? "active" : ""}`}><i className="far fa-chart-bar"></i><span className=' d-flex fw-bold mt-2'>Friends</span></Link>

      <Link onClick={() => {
        dispatch(Actions.setKeyTabBottom("Task"))
      }} to={routeLink.TASK} className={`d-flex flex-column justify-content-center tabs-bottom-item align-items-center ${curentPage == "task" ? "active" : ""}`}><i className="far fa-chart-bar"></i><span className=' d-flex fw-bold mt-2'>Task</span></Link>
    </div>
  )
}

export default Index;
